import React from 'react';
import { ErrorMessage } from './error-message';
export const Checkbox = React.forwardRef(({ error, ...props }, ref) => (<>
      <div style={{ marginTop: '7px' }}>
        <input ref={ref} {...props} type="checkbox"/>
      </div>
      <ErrorMessage error={error}></ErrorMessage>
    </>));
